<div class="monitor-layout">
  <div class="monitor-container">

    <!-- Unified Header -->
    <div class="unified-header">
      <div class="header-left">
        <button mat-icon-button (click)="goBack()" class="circular-button back-button" matTooltip="Regresar">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">
          <mat-icon class="title-icon">people</mat-icon>
          Administración de Usuarios y Roles
        </h1>
      </div>
    </div>

    <!-- Spinner Global -->
    @if (isLoadingSignal()) {
    <div class="spinner-container">
      <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
    </div>
    } @else {

    <!-- Gestión de Roles -->
    <div class="roles-section">
      <div class="section-header">
        <h2>
          <mat-icon>security</mat-icon>
          Roles del Sistema
        </h2>
        <button mat-raised-button color="primary" (click)="openRoleDialog()">
          <mat-icon>add</mat-icon>
          Nuevo Rol
        </button>
      </div>

      @if (roleService.isLoadingSignal()) {
      <div class="spinner-container-small">
        <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
      </div>
      } @else {
      <div class="roles-grid">
        @for (role of rolesSignal(); track role.id) {
        <mat-card class="role-card">
          <mat-card-header>
            <mat-card-title>{{role.name}}</mat-card-title>
            <mat-card-subtitle>{{role.users.length || 0}} usuarios asignados</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p class="role-description">{{role.description || 'Sin descripción'}}</p>
            <div class="permissions-chips">
              @for (perm of role.permissions.slice(0, 3); track perm) {
              <mat-chip>{{perm}}</mat-chip>
              }
              @if (role.permissions.length > 3) {
              <mat-chip>+{{role.permissions.length - 3}} más</mat-chip>
              }
            </div>
          </mat-card-content>
          <mat-card-actions align="end">
            <button mat-button color="primary" (click)="openRoleDialog(role)">
              <mat-icon>edit</mat-icon>
              Editar
            </button>
            <button mat-button color="warn" (click)="deleteRole(role)">
              <mat-icon>delete</mat-icon>
              Eliminar
            </button>
          </mat-card-actions>
        </mat-card>
        }
      </div>
      }
    </div>

    <!-- Filtros Colapsables Compactos -->
    <mat-expansion-panel class="filters-panel-compact" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div style="display: flex; align-items: center; gap: 6px;">
            <mat-icon>filter_list</mat-icon>
            <span>Filtros</span>
            @if (isFilteringSignal()) {
            <mat-progress-spinner mode="indeterminate" diameter="20" class="filter-spinner"
              style="margin-left: 2px;"></mat-progress-spinner>
            }
          </div>
        </mat-panel-title>
        <mat-panel-description>
          <span>{{ filteredUsersSignal().length }} usuarios encontrados</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <form class="filtros-form-compact">
        <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
          <mat-label>Buscar usuarios</mat-label>
          <input matInput [formControl]="searchControl">
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <div class="filter-actions">
          <button mat-icon-button color="primary" (click)="limpiarFiltros()" type="button" matTooltip="Limpiar Filtros"
            [disabled]="!searchControl.value">
            <mat-icon>filter_alt_off</mat-icon>
          </button>
          <button mat-icon-button color="accent" (click)="forzarRefrescoCompleto()" type="button" matTooltip="Refrescar"
            [disabled]="isLoadingSignal()">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </form>
    </mat-expansion-panel>

    <!-- Controles Superiores: Paginador -->
    <div class="controles-superiores">
      @if (filteredUsersSignal().length > 0) {
      <div class="top-paginator">
        <mat-paginator [length]="filteredUsersSignal().length" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
          [pageSizeOptions]="[10, 20, 50]" (page)="handlePageEvent($event)" showFirstLastButtons>
        </mat-paginator>
      </div>
      }
    </div>

    <!-- Table -->
    <div class="table-container mat-elevation-z8">
      <table mat-table [dataSource]="paginatedUsersSignal()">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Nombre </th>
          <td mat-cell *matCellDef="let user"> {{user.name}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Correo Electrónico </th>
          <td mat-cell *matCellDef="let user"> {{user.email}} </td>
        </ng-container>

        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef> Roles </th>
          <td mat-cell *matCellDef="let user">
            <span class="user-roles">{{getUserRoleNames(user.id)}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Estatus </th>
          <td mat-cell *matCellDef="let user">
            @if (user.status) {
            <span class="status-badge status-{{user.status.toLowerCase()}}">{{user.status}}</span>
            } @else {
            <span class="status-badge status-disabled">No definido</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef> Fecha de Creación </th>
          <td mat-cell *matCellDef="let user"> {{user.createdAt | date:'dd/MM/yyyy HH:mm'}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Acciones </th>
          <td mat-cell *matCellDef="let user">
            <button mat-icon-button color="primary" (click)="openUserDetail(user)" matTooltip="Ver detalles y roles">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      @if (filteredUsersSignal().length === 0) {
      <div class="no-data-message">
        <p>No se encontraron usuarios con los filtros aplicados</p>
        <button mat-raised-button color="primary" (click)="limpiarFiltros()">Limpiar Filtros</button>
      </div>
      }
    </div>

    <!-- Bottom Paginator -->
    @if (filteredUsersSignal().length > pageSize()) {
    <div class="bottom-paginator">
      <mat-paginator [length]="filteredUsersSignal().length" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
        [pageSizeOptions]="[10, 20, 50]" (page)="handlePageEvent($event)" showFirstLastButtons>
      </mat-paginator>
    </div>
    }
    }
  </div>
</div>